export default "__VITE_ASSET__34537cd5__"